module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-magenetic-link-generator","short_name":"magenetic-link","start_url":"/","background_color":"#FFFFFF","theme_color":"#663399","display":"minimal-ui","icon":"src/images/gatsby-icon.png"},
    }]
